var _style, _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowledgeBaseIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KnowledgeBaseIconActive-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: none;stroke: #ff377f;stroke-linecap: round } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m4.5 18.5v-7.5h13v7c-0.5 2-3 3.5-6 3.5-3 0-6-0.5-7-3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m21 7v8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.9
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.4 14l-9-5.7c-0.7-0.3-0.7-1.3 0-1.6l9-5.7c1-0.6 2.2-0.6 3.2 0l9 5.7c0.7 0.3 0.7 1.3 0 1.6l-9 5.7c-1 0.6-2.2 0.6-3.2 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.4 13l-7.1-4.7c-0.6-0.4-0.6-1.2 0-1.6l7.1-4.7c1-0.6 2.2-0.6 3.2 0l7.5 4.6c0.7 0.4 0.7 1.4 0 1.8l-7.5 4.6c-1 0.6-2.2 0.6-3.2 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBaseIconActive);
export default __webpack_public_path__ + "static/media/KnowledgeBaseIconActive.2e3e96dd22c6fbbf2599ee5ec10f1e07.svg";
export { ForwardRef as ReactComponent };